import { useEffect, useState } from "react"

import { PSEUDO_ID_COOKIE } from "@lib/constants"
import { getSessionCookie } from "@lib/util/get-session-cookie-client"

/**
 * Custom hook to manage session ID on client-side only
 * Prevents hydration mismatches by generating session ID after mount
 */
export const useClientSessionId = () => {
  const [sessionId, setSessionId] = useState<string>("")
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
    setSessionId(getSessionCookie(PSEUDO_ID_COOKIE) || "")
  }, [])

  return { sessionId, isMounted }
}
